module.exports = __webpack_public_path__ + "img/4b76f973835a5849c2c750826be7b3c8.png";